// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-diet-template-page {
  padding: 30px;
  background-color: #A5D6A7;
  border-radius: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  width: 800px;
  max-width: 90%;
  margin: 50px auto;
  font-family: 'Rubik', sans-serif;
}

.page-title1 {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
}

.loading-text {
  text-align: center;
  font-size: 18px;
  color: #555;
}

form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

label {
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.small-input {
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  width: 97%;
  margin-top: 8px;
}

.large-input {
  padding: 15px;
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  width: 100%;
  resize: vertical;
  margin-top: 8px;
  min-height: 300px;
}

.small-input:focus,
.large-input:focus {
  border-color: #388E3C;
  outline: none;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);
}

.edit-template-btn-group {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.edit-template-btn-update {
  background: #004D40;
  color: #fff;
  border: none;
  padding: 15px;
  border-radius: 15px;
  font-size: 18px;
  font-family: 'Rubik', sans-serif;
  cursor: pointer;
  font-weight: 600;
  flex: 1 1;
  max-width: 250px;
  min-width: 200px;
  transition: all 0.3s ease;
}

.edit-template-btn-cancel {
  background: #dc3545;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 15px;
  font-size: 18px;
  font-family: 'Rubik', sans-serif;
  cursor: pointer;
  font-weight: 600;
  flex: 1 1;
  max-width: 250px;
  min-width: 200px;
  transition: all 0.3s ease;
}

.edit-template-btn-update:hover {
  background: #2E7D32;
  transform: translateY(-2px);
}

.edit-template-btn-cancel:hover {
  background: #c82333;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .edit-template-btn-group {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .edit-template-btn-update,
  .edit-template-btn-cancel {
    width: 100%;
    max-width: 100%;
  }
}

.success-message-container {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.success-message13 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message13 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

.success-message .icon {
  font-size: 1.2em;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}`, "",{"version":3,"sources":["webpack://./src/styles/EditDietTemplatePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD","sourcesContent":[".edit-diet-template-page {\n  padding: 30px;\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  width: 800px;\n  max-width: 90%;\n  margin: 50px auto;\n  font-family: 'Rubik', sans-serif;\n}\n\n.page-title1 {\n  text-align: center;\n  font-size: 28px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 30px;\n}\n\n.loading-text {\n  text-align: center;\n  font-size: 18px;\n  color: #555;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\nlabel {\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.small-input {\n  padding: 10px;\n  font-size: 16px;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n  width: 97%;\n  margin-top: 8px;\n}\n\n.large-input {\n  padding: 15px;\n  font-size: 16px;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n  width: 100%;\n  resize: vertical;\n  margin-top: 8px;\n  min-height: 300px;\n}\n\n.small-input:focus,\n.large-input:focus {\n  border-color: #388E3C;\n  outline: none;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);\n}\n\n.edit-template-btn-group {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 30px;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n}\n\n.edit-template-btn-update {\n  background: #004D40;\n  color: #fff;\n  border: none;\n  padding: 15px;\n  border-radius: 15px;\n  font-size: 18px;\n  font-family: 'Rubik', sans-serif;\n  cursor: pointer;\n  font-weight: 600;\n  flex: 1;\n  max-width: 250px;\n  min-width: 200px;\n  transition: all 0.3s ease;\n}\n\n.edit-template-btn-cancel {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 15px;\n  border-radius: 15px;\n  font-size: 18px;\n  font-family: 'Rubik', sans-serif;\n  cursor: pointer;\n  font-weight: 600;\n  flex: 1;\n  max-width: 250px;\n  min-width: 200px;\n  transition: all 0.3s ease;\n}\n\n.edit-template-btn-update:hover {\n  background: #2E7D32;\n  transform: translateY(-2px);\n}\n\n.edit-template-btn-cancel:hover {\n  background: #c82333;\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .edit-template-btn-group {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n  \n  .edit-template-btn-update,\n  .edit-template-btn-cancel {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.success-message13 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message13 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n.success-message .icon {\n  font-size: 1.2em;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
